// const data = Array.from({length: 8}).map((_, id) => (
//   require(`images/partners/partner-${id + 1}.png`)
// ));
const data = [
  [
    Array.from({length: 8}).map((_, id) => require(`images/partners/${id + 1}.png`)),
    Array.from({length: 7}).map((_, id) => require(`images/partners/${id + 9}.png`))
  ],
  [
    Array.from({ length: 5 }).map((_, id) => require(`images/partners/backers/${id + 1}.png`))
  ]
];
console.log(data)
export default data;